import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@authentication/services/auth.service';
import { RoutePath } from '@shared/route-path.enum';

export const userActiveGuard = (_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) => {
	const authService = inject(AuthService);
	const router = inject(Router);
	if (authService.user?.is_active) {
		return true;
	}
	router.navigate([RoutePath.INACTIVE_ACCOUNT]);
	return false;
};
